import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import {
  InternationalShipmentContentType,
  InternationalShipmentContentTypeToDisplayText,
} from '@pdqdev/pdq-shared/dist/interfaces';
import { dutiesResponsibleOptions, incotermFields, merchantizeCategoriesOptions } from '../model';

@Component({
  selector: 'app-incoterm',
  templateUrl: './incoterm.component.html',
  styleUrls: ['./incoterm.component.scss', '../international.component.scss', '../../settings.scss'],
  standalone: false,
})
export class IncotermComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() dirty: boolean = false;
  @Input() dynamicFields;
  fields: any = incotermFields;

  dutiesOptions = [...dutiesResponsibleOptions];
  merchantCategories = merchantizeCategoriesOptions;
  contentTypes = Object.values(InternationalShipmentContentType);
  contentTypesDisplay = (type: InternationalShipmentContentType) =>
    InternationalShipmentContentTypeToDisplayText.get(type);
  constructor() {}

  ngOnInit(): void {
    // dutiesResponsibleOptions
    if (this.dynamicFields?.incoterm?.length) {
      this.dutiesOptions.push(...this.dynamicFields.incoterm);
    }
    this.onContentsTypeChanged({ value: this.form.get('contentsType').value, label: '' });
  }

  //UI events
  onDutiesResChecked(val) {}

  onCategoryChanged(val) {}

  isControlInvalid(controlName) {
    return this.dirty && !this.form.controls[controlName].valid;
  }

  onContentsTypeChanged(option: DropdownOption) {
    const descriptionControl = this.form.get('contentsTypeDescription');
    if (option.value === InternationalShipmentContentType.OTHER) {
      descriptionControl.setValidators([Validators.required]);
    } else {
      descriptionControl.clearValidators();
      descriptionControl.setErrors(null);
    }
  }
}
